<div class="client-datafeed-container">
  <h3>Client Data Feeds</h3>

  <div *ngIf="loading" class="loading">Loading feeds...</div>
  <div *ngIf="error" class="error">{{ error }}</div>

  <button class="btn btn-primary mb-2" (click)="addFeed()" [disabled]="isEditingAny">Add Feed</button>

  <div class="feed-card" *ngFor="let feed of feeds">
    <div class="feed-header" (click)="onHeaderToggle(feed)">
      <span>{{ feed.name }}</span>
      <span class="actions">
        <ng-container *ngIf="feed.clientId && !feed.editing">
          <button class="btn btn-sm btn-warning" (click)="editFeed(feed); $event.stopPropagation()">Edit</button>
          <button class="btn btn-sm btn-danger" (click)="deleteFeed(feed); $event.stopPropagation()">Delete</button>
        </ng-container>
      </span>
    </div>

    <div class="feed-edit" *ngIf="feed.editing">
      <div class="edit-section">
        <label>Name: <input [(ngModel)]="feed.name" /></label>
        <label>
          Source Client:
          <select [(ngModel)]="feed.sourceClientId" (ngModelChange)="onSourceClientChange(feed)">
            <option [ngValue]="''">-- Select Source Client --</option>
            <option *ngFor="let client of clients" [ngValue]="client.id">{{ client.displayName }}</option>
          </select>
        </label>
        <label>
          Dashboard:
          <select [(ngModel)]="feed.dashboardId">
            <option [ngValue]="''">-- Select Dashboard --</option>
            <option *ngFor="let def of dashboards" [ngValue]="def.id">{{ def.title }}</option>
          </select>
          <small *ngIf="dashboards.length === 0" style="color: #c00">Select a source client first to load dashboards.</small>
        </label>
        <label>
          Execution User:
          <span class="execution-user">
            <select [(ngModel)]="feed.executionUserId">
              <option [ngValue]="''">-- None --</option>
              <option *ngFor="let user of users" [ngValue]="user.id">{{ user.username }}</option>
            </select>
            <button type="button" class="btn btn-sm btn-secondary" *ngIf="feed.executionUserId" (click)="feed.executionUserId = ''">Clear</button>
          </span>
        </label>
        <label>Auto Run <input type="checkbox" [(ngModel)]="feed.autoRun" /></label>
        <label>Include Calcs <input type="checkbox" [(ngModel)]="feed.includeCalcs" /></label>

        <label>
          Export Type:
          <select [(ngModel)]="feed.exportName" (ngModelChange)="onExportTypeChange(feed)">
            <option [ngValue]="''">-- None --</option>
            <option *ngFor="let t of exportTypes" [ngValue]="t">{{ t }}</option>
          </select>
        </label>

        <!-- JMA -->
        <ng-container *ngIf="feed.exportName === 'JMA' && feed.payload">
          <div class="export-section">
            <span class="export-label">Destination Emails:</span>
            <div class="email-list">
              <div class="email-row" *ngFor="let email of feed.payload.destEmails; let i = index; trackBy: trackByIndex">
                <input type="email" placeholder="name@example.com" [(ngModel)]="feed.payload.destEmails[i]" />
                <button type="button" class="btn btn-sm btn-danger" (click)="removeEmail(feed, i)">&times;</button>
              </div>
              <button type="button" class="btn btn-sm btn-secondary" (click)="addEmail(feed)">Add Email</button>
            </div>
          </div>
          <label>Template Path: <input [(ngModel)]="feed.payload.templatePath" placeholder="C:\templates\report.docx" /></label>
        </ng-container>

        <!-- Database -->
        <ng-container *ngIf="feed.exportName === 'Database' && feed.payload">
          <label>Auto Load Schema <input type="checkbox" [(ngModel)]="feed.payload.autoLoadSchema" /></label>
          <label>
            Connection:
            <select [(ngModel)]="feed.payload.connectionId">
              <option [ngValue]="''">-- Select Connection --</option>
              <option *ngFor="let c of dataConnections" [ngValue]="c.id">{{ c.name }}</option>
            </select>
            <small *ngIf="dataConnections.length === 0" style="color: #c00">No 'Data' connections found for this client.</small>
          </label>
          <label>Use Legacy Ids <input type="checkbox" [(ngModel)]="feed.payload.useLegacyIds" /></label>
        </ng-container>

        <!-- FileExport -->
        <ng-container *ngIf="feed.exportName === 'FileExport' && feed.payload">
          <label>
            Transfer Format:
            <select [(ngModel)]="feed.payload.transferFormat">
              <option [ngValue]="''">-- Select Format --</option>
              <option *ngFor="let f of transferFormats" [ngValue]="f">{{ f }}</option>
            </select>
          </label>
          <label>
            Connection:
            <select [(ngModel)]="feed.payload.connectionId">
              <option [ngValue]="''">-- Select Connection --</option>
              <option *ngFor="let c of fileConnections" [ngValue]="c.id">{{ c.name }}</option>
            </select>
            <small *ngIf="fileConnections.length === 0" style="color: #c00">No 'File' connections found for this client.</small>
          </label>
          <label *ngIf="feed.payload.transferFormat === 'CSV'">
            Partner Code: <input [(ngModel)]="feed.payload.partnerCode" />
          </label>
          <label>Use Legacy Sync <input type="checkbox" [(ngModel)]="feed.payload.useLegacySync" /></label>
          <label>Use Legacy Ids <input type="checkbox" [(ngModel)]="feed.payload.useLegacyIds" /></label>

          <!-- Direct Exchange (legacy) - CSV only -->
          <label *ngIf="feed.payload.transferFormat === 'CSV'">
            Use Direct Exchange (legacy) <input type="checkbox" [(ngModel)]="feed.payload.useDirectExchange" />
          </label>

          <ng-container *ngIf="feed.payload.transferFormat === 'CSV' && feed.payload.useDirectExchange">
            <label>
              Tier Database Name (required): <input [(ngModel)]="feed.payload.tierDatabaseName" />
            </label>
            <label>Auto Load Xref <input type="checkbox" [(ngModel)]="feed.payload.autoLoadXref" /></label>

            <div class="export-section">
              <span class="export-label">Auto Load Recipients (optional):</span>
              <div class="email-list">
                <div class="email-row" *ngFor="let email of feed.payload.autoLoadRecipients; let i = index; trackBy: trackByIndex">
                  <input type="email" placeholder="name@example.com" [(ngModel)]="feed.payload.autoLoadRecipients[i]" />
                  <button type="button" class="btn btn-sm btn-danger" (click)="removeRecipient(feed, i)">&times;</button>
                </div>
                <button type="button" class="btn btn-sm btn-secondary" (click)="addRecipient(feed)">Add Recipient</button>
              </div>
            </div>

            <div class="export-section" *ngIf="isDeveloper && feed.id">
              <button type="button" class="btn btn-sm btn-secondary" (click)="openMappings(feed)">Manage Well Mappings</button>
            </div>
            <small *ngIf="!feed.id" style="color: #c00">Save this feed before managing well mappings.</small>
          </ng-container>
        </ng-container>

        <div class="edit-actions">
          <button class="save" (click)="saveFeed(feed)">Save</button>
          <button class="cancel" (click)="cancelEdit(feed)">Cancel</button>
        </div>
      </div>
    </div>
  </div>
</div>
